const state = () => ({
  openedModal: {
    id: null,
    payload: null,
  },
})

const getters = {
  openedModal(state) {
    return state.openedModal
  },
  openedModalId(state) {
    return state.openedModal.id
  },
  openedModalPayload(state) {
    return state.openedModal.payload
  },
}

const actions = {
  async setModalPayload({ commit }, payload) {
    await commit('SET_MODAL_PAYLOAD', payload)
  },

  async showModal({ commit }, payload) {
    await commit('SHOW_MODAL', payload)
  },

  async closeModal({ commit }) {
    return new Promise((resolve) => {
      commit('CLOSE_MODAL')
      setTimeout(() => {
        resolve()
      }, 500)
    })
  },
}

const mutations = {
  SET_MODAL_PAYLOAD: (state, payload) => {
    state.openedModal.payload = payload
  },

  SHOW_MODAL: (state, modalId) => {
    state.openedModal.id = modalId
  },

  CLOSE_MODAL: (state) => {
    state.openedModal.id = null
    state.openedModal.payload = null
  },
}

export default {
  state, getters, actions, mutations,
}